module.exports = __webpack_public_path__ + "media/icons/send-be7f5b9a.svg";